import React, { useContext } from 'react'
import { SortOption } from 'search/enums/search'
export interface SearchGridContextProps {
  hiddenFilters: Set<string> // controls which filters to visually hide
  filters?: string
  sortOption?: string
  hasNewProductOnly: boolean
  ruleContexts?: string[]
}
const SearchGridContext = React.createContext<Partial<SearchGridContextProps>>({
  hiddenFilters: new Set(),
  filters: '',
  sortOption: SortOption.Popular,
})

export const useGridContext = () => useContext(SearchGridContext)
SearchGridContext.displayName = 'SearchGridContext'
export default SearchGridContext
